import Link from "gatsby-link";
import React from "react";

import {
  fieldName,
  fieldUrlPath,
  isList,
  isNonNull,
  isNonNullList,
} from "utils/fields";

export const FieldType = ({ field }) => {
  return (
    <span>
      {isList(field.type) && "["}
      <Link to={fieldUrlPath(field.type)} className="object-field-type">
        {fieldName(field.type)}
        {isNonNull(field.type) && "!"}
      </Link>
      {isList(field.type) && "]"}
      {isNonNullList(field.type) && "!"}
    </span>
  );
};

export const FieldTypeExtra = ({ field }) => {
  if (!(field.defaultValue || field.description)) return null;

  return (
    <div className="object-field-type-extra">
      {field.defaultValue ? (
        <div>
          <span>Default Value:</span> {field.defaultValue}
        </div>
      ) : null}
      {field.description ? (
        <div>
          <span>Description:</span> {field.description}
        </div>
      ) : null}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/FieldType.jsx